import React, { useCallback, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text } from 'components/ui';
import RewardsCarousel from 'components/Content/BeautyInsider/RewardsCarousel';
import anaConstants from 'analytics/constants';
import BiRewardButton from 'components/Content/BeautyInsider/BiRewardButton';

const RougeOnlyRewards = props => {
    const {
        availableRewards,
        isRougeExclusive,
        isAnonymous,
        user,
        basket,
        localization,
        loadRougeRewards
    } = props;

    useEffect(() => {
        if (isRougeExclusive && user.isInitialized && user.language) {
            loadRougeRewards(user.language.toLowerCase(), user.profileLocale);
        }
    }, [isRougeExclusive, user.isInitialized, user.language, user.profileLocale]);

    const renderBiButton = useCallback(({ analyticsContext, sku, carouselName }) => (
        <BiRewardButton
            sku={sku}
            analyticsContext={analyticsContext}
            isAnonymous={isAnonymous}
            basket={basket}
            carouselName={carouselName}
        />
    ), [isAnonymous, basket]);


    if (!isRougeExclusive || availableRewards.length === 0) {
        return null;
    }

    return (
        <Box marginTop={[6, null, 7]}>
            <Text
                is='h2'
                fontWeight='bold'
                fontSize={['md', null, 'lg']}
                marginBottom={4}
            >
                {localization.sectionTitle}
            </Text>
            <RewardsCarousel
                items={availableRewards}
                showPrice={true}
                showMarketingFlags={true}
                rougeBadgeText={localization.rougeBadge}
                renderBiButton={renderBiButton}
                analyticsContext={anaConstants.CONTEXT.BASKET_REWARDS}
                size='small'
                hideVariationText={true}
                carouselName={anaConstants.CAROUSEL_NAMES.ROUGE_REWARDS_CAROUSEL}
            />
        </Box>
    );
};

export default wrapFunctionalComponent(RougeOnlyRewards, 'RougeOnlyRewards');
